import { render, staticRenderFns } from "./TopFooterButton.vue?vue&type=template&id=37497a35&scoped=true&"
import script from "./TopFooterButton.vue?vue&type=script&lang=ts&"
export * from "./TopFooterButton.vue?vue&type=script&lang=ts&"
import style0 from "./TopFooterButton.vue?vue&type=style&index=0&id=37497a35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37497a35",
  null
  
)

export default component.exports